"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Close;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Close(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "close"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M53.535,50,91.768,11.768a2.5,2.5,0,0,0-3.536-3.536L50,46.465,11.768,8.232a2.5,2.5,0,0,0-3.536,3.536L46.465,50,8.232,88.232a2.5,2.5,0,0,0,3.536,3.536L50,53.535,88.232,91.768a2.5,2.5,0,0,0,3.536-3.536Z"
  }))));
}